import { useTranslation } from 'react-i18next';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { CheckmarkIcon } from 'components/CustomIcon';
import { CustomText, CustomTextDefault } from 'components/CustomText';
import { Container, Title } from './StepPendingApproval.styles';

export const StepPendingApproval = (): JSX.Element => {
  const { t } = useTranslation();
  const {
    return: { customText },
  } = usePTPConfigContext();

  return (
    <Container gap={8} justify="center" direction="column" align="center">
      <CheckmarkIcon width={56} height={56} />
      <Title>{t('RETURN_REQUEST_RECEIVED')}</Title>
      <CustomText
        text={customText.pendingApproval?.text}
        defaultText={CustomTextDefault.PendingApproval}
      />
    </Container>
  );
};
